import React from "react"
import { Col, Row } from "reactstrap"
import PropTypes from "prop-types"
import { SaveButton } from "components/Buttons"

const PublishNotificationModal = ({
  handlePublishWithoutNotification,
  handlePublishWithNotification,
  loading,
}) => {
  return (
    <React.Fragment>
      <Row>
        <p>
          Would you like to send a notification to your users that the
          experience has been published?
        </p>
      </Row>
      <Row>
        <Col>
          <SaveButton
            type="button"
            fullWidth={true}
            content="No"
            onClick={handlePublishWithoutNotification}
          />
        </Col>
        <Col>
          <SaveButton
            content="Send"
            fullWidth={true}
            onClick={handlePublishWithNotification}
          />
        </Col>
      </Row>
    </React.Fragment>
  )
}

PublishNotificationModal.propTypes = {
  handlePublishWithoutNotification: PropTypes.func,
  handlePublishWithNotification: PropTypes.func,
  loading: PropTypes.bool,
}

export default PublishNotificationModal
